import { render, staticRenderFns } from "./ofdnotificationconfig.vue?vue&type=template&id=877dea52&scoped=true"
import script from "./ofdnotificationconfig.vue?vue&type=script&lang=js"
export * from "./ofdnotificationconfig.vue?vue&type=script&lang=js"
import style0 from "./ofdnotificationconfig.vue?vue&type=style&index=0&id=877dea52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "877dea52",
  null
  
)

export default component.exports